import Image from 'app/Components/Shared/Image/image';
import React,{ useState } from 'react';
import { getImageProps } from 'app/utilities/ImageProps';
import SelectInput from '../../Shared/SelectInput/SelectInput';
function EsimSupportingDevices(props) {
    // data from WrapperEsimVideo component
    const {propsIContent, context} = props;
    const title= propsIContent?.title?.value;
    const note = propsIContent?.note?.value;
    const icon = getImageProps(propsIContent?.imageIcon,context);
    const iconAlt= icon.alt= 'icon';
    const manufacturers = propsIContent?.manufacturer?.value?.map((item)=>{
        const device = item?.device?.map(item => item);
        const name=item?.manufacturerName;
        return {
            device,
            name
        }
    });

    const [dataDevice,setDataDevice] = useState([]); // An object that contains arrays, has been transformed to access the component-SelectInput
    const [listManufacturer,setListManufacturer] = useState(); // List according to Manufacturer selection
    const [listVersions,setListVersions] = useState(); // List versions

    const initialization = (val)=>{ // initialization listes
        setListVersions([])
        setDataDevice(val)
    }

    //SelectInput-Manufacturer
    const onChangeManufacturer = (val) => {
        const data = manufacturers?.find(d => d.name == val); // find name Manufacturer
        if(data == undefined){ // If you click on defaultText
            initialization([])
            return;
        }
        setListManufacturer(data);
        const device = data?.device?.map((item,i)=> { //intended to be able to access the component-SelectInput
            let arr = [];
            arr.push(item.playerName);
            arr.push(i);
            return arr;
        });
        const dataObgManufacturer = {options: device}; // Inserting the data into the object to use a common component - SelectInput
        initialization(dataObgManufacturer?.options)
        let deviceSelectInput = document.getElementById('device-select-Input');
        deviceSelectInput.selectedIndex = 0;
    };

    //SelectInput-Device
    const onChangeDevice = (int)=>{
        const versions = listManufacturer?.device[int]?.versionsName?.map(item => item);
        setListVersions(versions);
    };

    return (
        <div className='container-esim-supporting'>
                <div className='wrapper-title-note-select'>
                {title.length > 0 && <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>}
                <div className='wrapper-lebel-select'>
                    <div className='wrapper-select'>
                        <div>
                            <SelectInput
                                onChange={(e) => onChangeManufacturer(e.target.value)}
                                options={manufacturers}
                                dataKey= 'name' 
                                dataValue= 'name' 
                                defaultText='בחר יצרן'
                                value='בחר יצרן'
                            ></SelectInput>  
                        </div>
                        <div>
                            <SelectInput
                                onChange={(e) => onChangeDevice(e.target.value)} 
                                options={dataDevice}
                                dataKey= {1} 
                                dataValue={0} 
                                defaultText='בחר מכשיר'
                                value='בחר מכשיר'
                                id='device-select-Input'
                            ></SelectInput> 
                        </div> 
                    </div>
                    <div className='list-type'>
                        <ul>
                            {listVersions?.map((item,i)=>
                                <li key={i}>
                                    <Image className='li-icon' src={require('./images/icon.svg')} alt={iconAlt} />
                                    {item}
                                </li>
                            )}
                        </ul> 
                    </div>
                </div>  
                <div className='wrapper-note-icon'>
                    {icon.src != null && <Image src={icon.src} alt={iconAlt} />}  
                    {note.length > 0 && <div dangerouslySetInnerHTML={{ __html: note }}></div>}
                </div>  
                </div> 
        </div>  
    ) 
};

export default EsimSupportingDevices;